/**
 * UnauthorizedScreen - 未授权访问拒绝页
 *
 * 触发场景：
 * - 首次进入 URL 未携带 access_token
 * - URL 携带的 access_token 在初始刷新时被后端拒绝
 * - 主动定时刷新被后端 unauthorized 拒绝
 * - 被动 401 兜底刷新失败
 */
import React from 'react';
import { ShieldOff } from 'lucide-react';

const UnauthorizedScreen: React.FC = () => {
  return (
    <div className="relative w-screen h-screen overflow-hidden bg-[#0a0a0c] flex items-center justify-center text-white">
      {/* 背景柔光 */}
      <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-red-600/10 blur-[150px] rounded-full pointer-events-none" />
      <div className="absolute -bottom-[20%] -right-[10%] w-[50%] h-[50%] bg-orange-600/5 blur-[150px] rounded-full pointer-events-none" />

      {/* 玻璃面板 */}
      <div
        className="glass-high relative z-10 max-w-md mx-4 px-10 py-12 rounded-2xl text-center"
        data-ui-element="true"
        style={{
          background: 'rgba(20, 20, 24, 0.6)',
          backdropFilter: 'blur(24px)',
          border: '1px solid rgba(255, 255, 255, 0.06)',
          boxShadow: '0 16px 48px rgba(0, 0, 0, 0.6)',
        }}
      >
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-red-500/15 flex items-center justify-center">
          <ShieldOff className="w-8 h-8 text-red-400" />
        </div>

        <h1 className="text-2xl font-semibold mb-3 text-white">访问受限</h1>

        <p className="text-sm text-slate-400 leading-relaxed">
          请通过授权入口访问 NewWeb。
        </p>
      </div>
    </div>
  );
};

export default UnauthorizedScreen;
